import React, { Component } from 'react'
import { Columns, Modal } from 'components/elements'
import PartnerContactForm from '../contactForm/contactForm'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_API_KEY, CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import { userPhotoID, USER_MEDIUM_PARAMS } from '../../../constants/images/sizesAndQuality'
import RatingStars from '../../elements/ratingStars'
import { apiProcess } from '../../api/api.js'
import DarkLoader from 'components/theme/assets/images/loaders/three-dots-dark.svg'
import moment from 'moment'
import SearchCard from '../../search/layout/card/searchCard.js'
import './partnerPopUp.css'
import { getPartnerButtonText, getPartnerContactFormText } from '../partnerUtil'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key: CLOUDINARY_API_KEY,
})

class PartnerPopUp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: false,
      loaded: false,
      motosInfo: [],
    }
  }

  componentDidMount() {}

  getMotoIDs = info => {
    let motoIDs = []

    for (let i = 0; i < info.length; i++) {
      motoIDs.push(info[i].bike_id)
    }

    return motoIDs
  }

  loadPartnerPopUp = () => {
    this.setState({ open: true })

    if (this.state.loaded) {
      return false
    }

    this.setState({ loading: true })

    let bikeIds = this.getMotoIDs(this.props.info)
    let get_count = 6 - bikeIds.length
    get_count = get_count > 0 ? get_count : 0 //if it's negative, then make it zero

    let currentIDs = [...bikeIds]
    if (currentIDs.length > 6) {
      currentIDs = currentIDs.slice(0, 6)
    }

    const listData = {
      motorcycle_pretty_ids: currentIDs.join(),
      additional_motorcycles_owner_pretty_id: this.props.info[0].bike_owner_id,
      get_additional_motorcycles: true,
      additional_motorcycles_count: get_count, //fix this up later
    }

    apiProcess('motorcycles/list', listData, 'get-bike-info-from-ids', 'Motorcycle dealer popup')
      .then(
        function(responseData) {
          //here we form the object

          // getting rid of dups
          let motorcyclesInfo = responseData.requested_motorcycles.concat(responseData.additional_motorcycles)

          motorcyclesInfo = motorcyclesInfo.filter(
            (ele, ind) => ind === motorcyclesInfo.findIndex((elem) => elem.id === ele.id),
          )

          this.setState({
            loading: false,
            loaded: true,
            motosInfo: motorcyclesInfo,
          })
        }.bind(this),
      )
      .catch(
        function(errorResponse) {
          this.setState({
            loading: false,
            error: true,
          })
        }.bind(this),
      )
  }

  render() {
    const { error, loading, motosInfo, open } = this.state
    const {
      startDate,
      endDate,
      info
    } = this.props

    let partnerCountLabelClass = 'map-multi-label'

    if (this.props.focused) {
      partnerCountLabelClass = 'map-multi-label map-multi-hovered'
    }

    return (
      <>
        <div
          onClick={() => this.loadPartnerPopUp()}
          className={partnerCountLabelClass}
          style={{
            backgroundImage: 'url(' + cl.url(userPhotoID(info[0].bike_owner_avatar_id), USER_MEDIUM_PARAMS) + ')',
          }}
        >
          <div className="map-multi-inner">
            <div className="tag is-secondary is-small is-floating">{info[0].partner_info?.partner_inventory_count ?? ''}</div>
          </div>
        </div>
        <Modal
          size="small"
          show={open}
          closeOnBlur={true}
          closeOnEsc={true}
          onClose={() => this.setState({ open: false })}
        >
        {!loading && !error && info?.length > 0 && (
          <React.Fragment>
            <Columns className="is-vcentered partner-search-popup-content pt-2">
              <Columns.Column size={2}>
                <a href={'/partners/' + info[0].bike_owner_id}>
                  <img
                    src={cl.url(userPhotoID(info[0].bike_owner_avatar_id), USER_MEDIUM_PARAMS)}
                    className="is-circular"
                    alt={`${info[0].partner_info.partner_name}'s Profile`}
                  />
                </a>
              </Columns.Column>
              <Columns.Column size={10}>
                <h2 className="title has-text-weight-extra-bold is-size-4">
                  {info[0].partner_info.partner_name}
                </h2>
                <p className="subtitle is-size-6 mb-0">Certified Twisted Road Partner</p>
                <p className="is-size-6">
                  {
                    info[0].partner_info.partner_location.city + ", " + 
                    info[0].partner_info.partner_location.region_abbreviation} 
                    - {info[0].bike_distance
                  } mi
                </p>
                {info[0].reviews?.length > 0 &&
                  <RatingStars 
                    rating={
                      Math.round(info[0].reviews.ratings_average * 10) / 10
                    }
                    ratingCount={info[0].reviews.ratings_count} 
                  />
                }
              </Columns.Column>
            </Columns>
            <Columns className="partner-pop-up-results-wrap">
              {motosInfo.map((result, index) => (
                <SearchCard
                  cardInfo={{
                    bike_id: result.pretty_id,
                    bike_year: result.year,
                    bike_make: result.make,
                    bike_model: result.model,
                    bike_location: {
                      city: result.location.city,
                      region_abbreviation: result.location.region_abbreviation,
                      country_abbreviation: result.location.country_abbreviation,
                    },
                    bike_image_cloudinary_public_id: result.images[0].cloudinary_public_id,
                    day_price_cents: result.daily_rental_price_cents,
                    day_price_currency: result.daily_rental_price_currency,
                    bike_owner_name: result.partner_info.partner_name,
                    average_rating: result.owner.reviews.ratings_average,
                    ratings_count: result.owner.reviews.ratings_count,
                  }}
                  titleSize="is-size-6"
                  className={'is-6'}
                  hideName={true}
                  hideLocation={true}
                  showDistance={false}
                  startDate={startDate}
                  endDate={endDate}
                />
              ))}
            </Columns>
          </React.Fragment>
        )}
          {loading && !error && (
            <Columns style={{ padding: '3rem 0' }}>
              <Columns.Column className="has-text-centered">
                <img src={DarkLoader} alt="Search GooseEgg Loading" style={{ height: '20px' }} />
              </Columns.Column>
            </Columns>
          )}

          {!loading && error && <div className="has-text-danger">We're having trouble right now.</div>}

          <div className="has-text-centered">
            <a
              className="is-primary button is-outlined is-normal has-text-weight-extra-bold"
              href={'/partners/' + info[0].bike_owner_id}
            >
              SEE ALL
            </a>
          </div>
        </Modal>
      </>
    )
  }
}

export default PartnerPopUp

PartnerPopUp.defaultProps = {
  startDate: null,
  endDate: null,
  focused: false,
}
